@if (isReadOnly()) {
  <div class="w-full h-full flex flex-col gap-6">
    @if (isFlightOnly()) {
      <div class="w-full flex-col">
        <div class="self-stretch justify-start text-text-color text-base font-medium font-['Inter'] leading-6">Project</div>
        <div class="flex gap-10">
          <div class="flex flex-col min-w-1/4">
            <div class="self-stretch justify-start text-text-color text-sm font-normal font-['Inter'] leading-5">Project Code</div>
            <div class="self-stretch justify-start text-text-color text-sm font-semibold font-['Inter'] line-clamp-1">{{taSubmission()?.projectCode  ?? "No project set."}}</div>
          </div>
          <div class="flex flex-col min-w-1/4">
            <div class="self-stretch justify-start text-text-color text-sm font-normal font-['Inter'] leading-5">{{ requiresPrimaryApprover() ? 'General Manager Approver' : 'Line Manager Approver' }}</div>
            <div class="self-stretch justify-start text-text-color text-sm font-semibold font-['Inter'] line-clamp-1" [title]="store.taSubmission()?.primaryApprover?.email">{{store.taSubmission()?.primaryApprover?.name ?? "No approver set."}}</div>
          </div>
          @if (!!store.taSubmission()?.delegate){
            <div class="flex flex-col min-w-1/4">
              <div class="self-stretch justify-start text-text-color text-sm font-normal font-['Inter'] leading-5">Booking Officer</div>
              <div class="self-stretch justify-start text-text-color text-sm font-semibold font-['Inter'] line-clamp-1" [title]="store.taSubmission()!.delegate!.email">{{store.taSubmission()!.delegate!.name}}</div>
            </div>
          }
        </div>
      </div>
    } @else {
      <div class="w-full flex-col">
        <div class="self-stretch justify-start text-text-color text-base font-medium font-['Inter'] leading-6">Project and Approver(s)</div>
        <div class="flex gap-10">
          <div class="flex flex-col min-w-1/4">
            <div class="self-stretch justify-start text-text-color text-sm font-normal font-['Inter'] leading-5">Project</div>
            <div class="self-stretch justify-start text-text-color text-sm font-semibold font-['Inter'] line-clamp-1">{{taSubmission()?.projectCode  ?? "No project set."}}</div>
          </div>
          @if (requiresPrimaryApprover()) {
            <div class="flex flex-col min-w-1/4">
              <div class="self-stretch justify-start text-text-color text-sm font-normal font-['Inter'] leading-5">General Manager Approver</div>
              <div class="self-stretch justify-start text-text-color text-sm font-semibold font-['Inter'] line-clamp-1" [title]="store.taSubmission()?.primaryApprover?.email">{{store.taSubmission()?.primaryApprover?.name ?? "No approver set."}}</div>
            </div>
          } @else {
            <div class="flex flex-col min-w-1/4">
              <div class="self-stretch justify-start text-text-color text-sm font-normal font-['Inter'] leading-5">Line Manager/Primary Approver</div>
              <div class="self-stretch justify-start text-text-color text-sm font-semibold font-['Inter'] line-clamp-1" [title]="store.taSubmission()?.primaryApprover?.email">{{store.taSubmission()?.primaryApprover?.name ?? "No approver set."}}</div>
            </div>
            <div class="flex flex-col min-w-1/4">
              <div class="self-stretch justify-start text-text-color text-sm font-normal font-['Inter'] leading-5">Funding Manager/Secondary Approver</div>
              <div class="self-stretch justify-start text-text-color text-sm font-semibold font-['Inter'] line-clamp-1" [title]="store.taSubmission()?.secondaryApprover?.email">{{store.taSubmission()?.secondaryApprover?.name ?? "No approver set."}}</div>
            </div>
          }
          @if (!!store.taSubmission()?.delegate){
            <div class="flex flex-col min-w-1/4">
              <div class="self-stretch justify-start text-text-color text-sm font-normal font-['Inter'] leading-5">Booking Officer</div>
              <div class="self-stretch justify-start text-text-color text-sm font-semibold font-['Inter'] line-clamp-1" [title]="store.taSubmission()!.delegate!.email">{{store.taSubmission()!.delegate!.name}}</div>
            </div>
          }
        </div>
      </div>
    }
    <div class="w-full h-[1px] bg-surface-200"></div>
    <div class="w-full flex-col">
      <div class="self-stretch justify-start text-text-color text-base font-medium font-['Inter'] leading-6">Purpose of Travel</div>
      <div class="flex gap-10">
        <div class="flex flex-col min-w-1/4">
          <div class="self-stretch justify-start text-text-color text-sm font-normal font-['Inter'] leading-5">Purpose</div>
          <div class="self-stretch justify-start text-text-color text-sm font-semibold font-['Inter'] line-clamp-1">{{taSubmission()!.purpose ?? "No purpose set."}}</div>
        </div>
        <div class="flex flex-col min-w-1/4">
          <div class="self-stretch justify-start text-text-color text-sm font-normal font-['Inter'] leading-5">More Details</div>
          <div class="self-stretch justify-start text-text-color text-sm font-semibold font-['Inter'] line-clamp-1">{{taSubmission()!.purposeNotes ?? "No purpose set."}}</div>
        </div>
      </div>
    </div>
    <div class="w-full h-[1px] bg-surface-200"></div>
    @if (isFlightOnly()) {
      <div class="w-full flex-col">
        <div class="self-stretch justify-start text-text-color text-base font-medium font-['Inter'] leading-6">Flights and Travel Dates</div>
        <div class="flex gap-10">
          <div class="flex flex-col min-w-1/4">
            <div class="self-stretch justify-start text-text-color text-sm font-normal font-['Inter'] leading-5">Flights</div>
            <div class="self-stretch justify-start text-text-color text-sm font-semibold font-['Inter'] line-clamp-1">{{ flightTripType() === 'oneWay' ? 'One way' : flightTripType() === 'return' ? 'Return' : '–' }}</div>
          </div>
          <div class="flex flex-col min-w-1/4">
            <div class="self-stretch justify-start text-text-color text-sm font-normal font-['Inter'] leading-5">First Flight</div>
            <div class="self-stretch justify-start text-text-color text-sm font-semibold font-['Inter'] line-clamp-1">{{ (taSubmission()!.startDate | date: "dd/MM/yy") ?? '–' }}</div>
          </div>
          <div class="flex flex-col min-w-1/4">
            <div class="self-stretch justify-start text-text-color text-sm font-normal font-['Inter'] leading-5">Second Flight</div>
            <div class="self-stretch justify-start text-text-color text-sm font-semibold font-['Inter'] line-clamp-1">{{ (secondFlightDate() | date: "dd/MM/yy") ?? '–' }}</div>
          </div>
        </div>
      </div>
    } @else {
      <div class="w-full flex-col">
        <div class="self-stretch justify-start text-text-color text-base font-medium font-['Inter'] leading-6">Duration of Travel</div>
        <div class="flex gap-10">
          <div class="flex flex-col min-w-1/4">
            <div class="self-stretch justify-start text-text-color text-sm font-normal font-['Inter'] leading-5">Start Date</div>
            <div class="self-stretch justify-start text-text-color text-sm font-semibold font-['Inter'] line-clamp-1">{{taSubmission()!.startDate | date: "dd/MM/yy"}}</div>
          </div>
          <div class="flex flex-col min-w-1/4">
            <div class="self-stretch justify-start text-text-color text-sm font-normal font-['Inter'] leading-5">End Date</div>
            <div class="self-stretch justify-start text-text-color text-sm font-semibold font-['Inter'] line-clamp-1">{{taSubmission()!.endDate | date: "dd/MM/yy"}}</div>
          </div>
        </div>
      </div>
    }
  </div>
} @else {
  <div class="w-full h-full flex flex-col gap-6">
    @if (isFlightOnly()) {
      <p-card>
        <div class="flex gap-2">
          <div class="flex flex-col w-64 bg-surface-0 p-6 gap-6 rounded-l-2xl shadow-[0px_1px_2px_-1px_rgba(0,0,0,0.10),0px_1px_3px_0px_rgba(0,0,0,0.10)]">
            <div class="self-stretch justify-start text-surface-800 text-base font-medium font-['Inter'] leading-6">Project</div>
            <div class="self-stretch justify-start text-surface-600 text-sm font-light font-['Inter']">Select the project for this TA.</div>
          </div>
          <div class="flex-1 bg-surface-50 p-6 rounded-r-2xl shadow-[0px_1px_2px_-1px_rgba(0,0,0,0.10),0px_1px_3px_0px_rgba(0,0,0,0.10)] flex gap-4">
            <div class="flex-col gap-2 flex-1">
              <div class="self-stretch justify-start"><span class="text-text-color text-sm font-normal font-['Inter'] leading-5">Project</span><span class="text-red-700 text-sm font-normal font-['Inter'] leading-5">*</span></div>
              <p-autocomplete [ngModel]="project()"
                              (onSelect)="updateProject('projectId', $event)"
                              [dropdown]="true"
                              [suggestions]="filteredProjects"
                              (completeMethod)="filterProjects($event)"
                              optionLabel="code"
                              [placeholder]="hasPrimaryTraveller() ? 'Type and/or select a project...' : 'Select a traveller first'"
                              size="small"
                              class="w-full"
                              [forceSelection]="true"
                              [disabled]="!hasPrimaryTraveller()"
                              appendTo="body"
              >
                <ng-template #item let-project>
                  <span>{{ project.code }}</span>
                </ng-template>
              </p-autocomplete>
              @if (noFlightOnlyProjects()) {
                <div class="text-surface-600 text-xs font-normal font-['Inter'] pt-1" data-testid="flight-only-no-projects">No projects found for this traveller's manager.</div>
              }
            </div>
            <div class="flex-col gap-2 flex-1">
              <!-- The server sets the line manager as approver; only a CEO/GM case picks one. -->
              @if (requiresPrimaryApprover()) {
                <div class="self-stretch justify-start"><span class="text-text-color text-sm font-normal font-['Inter'] leading-5">General Manager Approver</span><span class="text-red-700 text-sm font-normal font-['Inter'] leading-5">*</span></div>
                <p-select data-testid="primary-approver-select"
                          [ngModel]="taSubmission()?.primaryApprover"
                          (ngModelChange)="updateField('primaryApprover', {value: $event})"
                          [options]="availablePrimaryApprovers()"
                          optionLabel="name"
                          placeholder="Select a general manager..."
                          size="small"
                          class="w-full"
                          appendTo="body"
                          [disabled]="availablePrimaryApprovers().length === 0 || availablePrimaryApprovers().length === 1"
                ></p-select>
              }
            </div>
          </div>
        </div>
      </p-card>
    } @else {
      @if (requiresPrimaryApprover()) {
        <p-card>
          <div class="flex gap-2">
            <div class="flex flex-col w-64 bg-surface-0 p-6 gap-6 rounded-l-2xl shadow-[0px_1px_2px_-1px_rgba(0,0,0,0.10),0px_1px_3px_0px_rgba(0,0,0,0.10)]">
              <div class="self-stretch justify-start text-surface-800 text-base font-medium font-['Inter'] leading-6">
                {{ ['both', 'ceo'].includes(primaryApproverScenario()) ? 'Project and General Manager Approver' : 'Project and CEO Approver' }}
              </div>
              <div class="self-stretch justify-start text-surface-600 text-sm font-light font-['Inter']">
                {{ ['both', 'ceo'].includes(primaryApproverScenario()) ? '&#8288;Select the project and approver from the general manager list.' : '&#8288;Select the project and approver from the CEO list.'}}
              </div>
            </div>
            <div class="flex-1 bg-surface-50 p-6 rounded-r-2xl shadow-[0px_1px_2px_-1px_rgba(0,0,0,0.10),0px_1px_3px_0px_rgba(0,0,0,0.10)] flex gap-4">
              <div class="flex-col gap-2 flex-1">
                <div class="self-stretch justify-start"><span class="text-text-color text-sm font-normal font-['Inter'] leading-5">Project</span><span class="text-red-700 text-sm font-normal font-['Inter'] leading-5">*</span></div>
                <p-autocomplete [ngModel]="project()"
                                (onSelect)="updateProject('projectId', $event)"
                                [dropdown]="true"
                                [suggestions]="filteredProjects"
                                (completeMethod)="filterProjects($event)"
                                optionLabel="code"
                                placeholder="Type and/or select a project..."
                                size="small"
                                class="w-full"
                                [forceSelection]="true"
                                appendTo="body"
                >
                  <ng-template #item let-project>
                    <span>{{ project.code }}</span>
                  </ng-template>
                </p-autocomplete>
              </div>
              <div class="flex-col gap-2 flex-1">
                <div class="self-stretch justify-start"><span class="text-text-color text-sm font-normal font-['Inter'] leading-5">Approver</span><span class="text-red-700 text-sm font-normal font-['Inter'] leading-5">*</span></div>
                <p-select data-testid="primary-approver-select"
                          [ngModel]="taSubmission()?.primaryApprover"
                          (ngModelChange)="updateField('primaryApprover', {value: $event})"
                          [options]="availablePrimaryApprovers()"
                          optionLabel="name"
                          placeholder="Select a primary approver..."
                          size="small"
                          class="w-full"
                          appendTo="body"
                          [disabled]="availablePrimaryApprovers().length === 0 || availablePrimaryApprovers().length === 1"
                ></p-select>
              </div>
            </div>
          </div>
        </p-card>
      } @else {
        <p-card>
          <div class="flex gap-2">
            <div class="flex flex-col w-64 bg-surface-0 p-6 gap-6 rounded-l-2xl shadow-[0px_1px_2px_-1px_rgba(0,0,0,0.10),0px_1px_3px_0px_rgba(0,0,0,0.10)]">
              <div class="self-stretch justify-start text-surface-800 text-base font-medium font-['Inter'] leading-6">Project and Approver</div>
              <div class="self-stretch justify-start text-surface-600 text-sm font-light font-['Inter']">Select the project and the person who will approve the TA.</div>
            </div>
            <div class="flex-1 bg-surface-50 p-6 rounded-r-2xl shadow-[0px_1px_2px_-1px_rgba(0,0,0,0.10),0px_1px_3px_0px_rgba(0,0,0,0.10)] flex gap-4 ">
              <div class="flex-col gap-2 flex-1">
                <div class="self-stretch justify-start"><span class="text-text-color text-sm font-normal font-['Inter'] leading-5">Project</span><span class="text-red-700 text-sm font-normal font-['Inter'] leading-5">*</span></div>
                <p-autocomplete [ngModel]="project()"
                                (onSelect)="updateProject('projectId', $event)"
                                [dropdown]="true"
                                [suggestions]="filteredProjects"
                                (completeMethod)="filterProjects($event)"
                                optionLabel="code"
                                placeholder="Type and/or select a project..."
                                size="small"
                                class="w-full"
                                [forceSelection]="true"
                                appendTo="body"
                >
                  <ng-template #item let-project>
                    <span>{{ project.code }}</span>
                  </ng-template>
                </p-autocomplete>
              </div>
              <div class="flex-col gap-2 flex-1">
                <div class="self-stretch justify-start"><span class="text-text-color text-sm font-normal font-['Inter'] leading-5">Approver</span><span class="text-red-700 text-sm font-normal font-['Inter'] leading-5">*</span></div>
                <p-autocomplete [ngModel]="this.taSubmission()?.secondaryApprover"
                                (onSelect)="updateField('secondaryApprover', $event)"
                                [dropdown]="true"
                                [suggestions]="filteredApprovers"
                                (completeMethod)="filterApprovers($event)"
                                optionLabel="name"
                                placeholder="Select an approver..."
                                size="small"
                                class="w-full"
                                [forceSelection]="true"
                                [disabled]="availableApprovers().length === 0 || availableApprovers().length === 1"
                ></p-autocomplete>
              </div>
            </div>
          </div>
        </p-card>
      }
    }

    <p-card>
      <div class="flex gap-2">
        <div class="flex flex-col w-64 bg-surface-0 p-6 gap-6 rounded-l-2xl shadow-[0px_1px_2px_-1px_rgba(0,0,0,0.10),0px_1px_3px_0px_rgba(0,0,0,0.10)]">
          <div class="self-stretch justify-start text-surface-800 text-base font-medium font-['Inter'] leading-6">Purpose of the Travel</div>
        </div>
        <div class="flex-1 bg-surface-50 p-6 rounded-r-2xl shadow-[0px_1px_2px_-1px_rgba(0,0,0,0.10),0px_1px_3px_0px_rgba(0,0,0,0.10)] flex gap-4">
          <div class="flex-col gap-2 flex-1">
            <div class="self-stretch justify-start"><span class="text-text-color text-sm font-normal font-['Inter'] leading-5">Purpose of the Travel</span><span class="text-red-700 text-sm font-normal font-['Inter'] leading-5">*</span></div>
            <p-autocomplete [ngModel]="taSubmission()?.purpose"
                            (onSelect)="updateField('purpose', $event)"
                            [dropdown]="true"
                            [suggestions]="filteredPurposes"
                            (completeMethod)="filterPurposes($event)"
                            optionLabel="label"
                            placeholder="Purpose of the travel..."
                            size="small"
                            class="w-full"
                            [forceSelection]="true"
            ></p-autocomplete>
          </div>
          <div class="flex-col gap-2 flex-1">
            <div class="self-stretch justify-start"><span class="text-text-color text-sm font-normal font-['Inter'] leading-5">More Details</span><span class="text-red-700 text-sm font-normal font-['Inter'] leading-5">*</span></div>
            <textarea pTextarea
                      [value]="taSubmission()?.purposeNotes"
                      (change)="updateField('purposeNotes', $event)"
                      [autoResize]="true"
                      data-testid="create-ta-purpose-notes"
                      placeholder="Provide more details..."
                      rows="1"
                      pSize="small"
                      class="w-full"
                      [disabled]="!taSubmission()?.purpose"
            ></textarea>
          </div>
        </div>
      </div>
    </p-card>

    @if (isFlightOnly()) {
      <p-card>
        <div class="flex gap-2">
          <div class="flex flex-col w-64 bg-surface-0 p-6 gap-6 rounded-l-2xl shadow-[0px_1px_2px_-1px_rgba(0,0,0,0.10),0px_1px_3px_0px_rgba(0,0,0,0.10)]">
            <div class="self-stretch justify-start text-surface-800 text-base font-medium font-['Inter'] leading-6">Flights and Travel Dates</div>
            <div class="self-stretch justify-start text-surface-600 text-sm font-light font-['Inter']">Choose one way or return, then select your flight dates.</div>
          </div>
          <div class="flex-1 bg-surface-50 p-6 rounded-r-2xl shadow-[0px_1px_2px_-1px_rgba(0,0,0,0.10),0px_1px_3px_0px_rgba(0,0,0,0.10)] flex flex-col gap-4">
            <div class="flex flex-col gap-2">
              <div class="self-stretch justify-start"><span class="text-text-color text-sm font-normal font-['Inter'] leading-5">Is this TA for a one-way flight or return flights?</span><span class="text-red-700 text-sm font-normal font-['Inter'] leading-5">*</span></div>
              <div class="flex gap-6">
                <div class="flex items-center gap-2">
                  <p-radiobutton inputId="flight-trip-one-way" name="flightTripType" value="oneWay" size="small"
                                 [ngModel]="flightTripType()" (ngModelChange)="setFlightTripType($event)"></p-radiobutton>
                  <label for="flight-trip-one-way" class="text-text-color text-sm font-normal font-['Inter']">One way</label>
                </div>
                <div class="flex items-center gap-2">
                  <p-radiobutton inputId="flight-trip-return" name="flightTripType" value="return" size="small"
                                 [ngModel]="flightTripType()" (ngModelChange)="setFlightTripType($event)"></p-radiobutton>
                  <label for="flight-trip-return" class="text-text-color text-sm font-normal font-['Inter']">Return</label>
                </div>
              </div>
            </div>
            <div class="flex-col gap-2">
              <div class="self-stretch justify-start"><span class="text-text-color text-sm font-normal font-['Inter'] leading-5">First Flight</span><span class="text-red-700 text-sm font-normal font-['Inter'] leading-5">*</span></div>
              <p-datepicker [ngModel]="startDate()"
                            (ngModelChange)="updateFirstFlight($event)"
                            [iconDisplay]="'input'"
                            [showIcon]="true"
                            [dateFormat]="'dd/mm/yy'"
                            [readonlyInput]="true"
                            [maxDate]="flightTripType() === 'return' ? firstFlightMaxDate() : null"
                            [disabled]="!flightTripType()"
                            placeholder="DD/MM/YY"
                            size="small"
                            appendTo="body"
                            data-testid="flight-first-date"
              ></p-datepicker>
            </div>
            <div class="flex-col gap-2">
              <div class="self-stretch justify-start"><span class="text-text-color text-sm font-normal font-['Inter'] leading-5">Second Flight</span>@if (flightTripType() === 'return') {<span class="text-red-700 text-sm font-normal font-['Inter'] leading-5">*</span>}</div>
              <p-datepicker [ngModel]="secondFlightDate()"
                            (ngModelChange)="updateField('endDate', $event)"
                            [iconDisplay]="'input'"
                            [showIcon]="true"
                            [dateFormat]="'dd/mm/yy'"
                            [readonlyInput]="true"
                            [minDate]="secondFlightMinDate()"
                            [disabled]="flightTripType() !== 'return' || !startDate()"
                            placeholder="DD/MM/YY"
                            size="small"
                            appendTo="body"
                            data-testid="flight-second-date"
              ></p-datepicker>
            </div>
          </div>
        </div>
      </p-card>
    } @else {
      <p-card>
        <div class="flex gap-2">
          <div class="flex flex-col w-64 bg-surface-0 p-6 gap-6 rounded-l-2xl shadow-[0px_1px_2px_-1px_rgba(0,0,0,0.10),0px_1px_3px_0px_rgba(0,0,0,0.10)]">
            <div class="self-stretch justify-start text-surface-800 text-base font-medium font-['Inter'] leading-6">Duration of the Travel</div>
            <div class="self-stretch justify-start text-surface-600 text-sm font-light font-['Inter']">Select the start and end dates of your planned trip.</div>
          </div>
          <div class="flex-1 bg-surface-50 p-6 rounded-r-2xl shadow-[0px_1px_2px_-1px_rgba(0,0,0,0.10),0px_1px_3px_0px_rgba(0,0,0,0.10)] flex gap-4">
            <div class="flex-col gap-2">
              <div class="self-stretch justify-start"><span class="text-text-color text-sm font-normal font-['Inter'] leading-5">Travel Start Date</span><span class="text-red-700 text-sm font-normal font-['Inter'] leading-5">*</span></div>
              <p-datepicker [ngModel]="startDate()"
                            (ngModelChange)="updateField('startDate', $event)"
                            [iconDisplay]="'input'"
                            [showIcon]="true"
                            [dateFormat]="'dd/mm/yy'"
                            [readonlyInput]="true"
                            placeholder="DD/MM/YY"
                            size="small"
                            appendTo="body"
              ></p-datepicker>
            </div>
            <div class="flex-col gap-2">
              <div class="self-stretch justify-start"><span class="text-text-color text-sm font-normal font-['Inter'] leading-5">Travel End Date</span><span class="text-red-700 text-sm font-normal font-['Inter'] leading-5">*</span></div>
              <p-datepicker [ngModel]="endDate()"
                            (ngModelChange)="updateField('endDate', $event)"
                            [iconDisplay]="'input'"
                            [showIcon]="true"
                            [dateFormat]="'dd/mm/yy'"
                            [readonlyInput]="true"
                            [minDate]="startDate()"
                            [disabled]="!startDate()"
                            placeholder="DD/MM/YY"
                            size="small"
                            appendTo="body"
              ></p-datepicker>
            </div>
          </div>
        </div>
      </p-card>
    }
  </div>
}
